// extracted by mini-css-extract-plugin
export default {"mediaBlock":"MediaBlock_mediaBlock__pZlRy","caption":"MediaBlock_caption__VYGZX"};